import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Form,
  Row,
  Spinner,
} from "react-bootstrap";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import WebService from "../../Services/WebService";
import { toast } from "react-toastify";
import Loader from "../../components/Loader/Loader";
import { BiArrowBack } from "react-icons/bi";

const AddCountries = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = (queryParams.get("type") ?? "COURSE").toUpperCase();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const [loading, setLoading] = useState(false);
  const [loader, setShowLoader] = useState(false);
  const [data, setData] = useState({});
  const [error, setError] = useState(false);
  const [isAccess, setIsAccess] = useState(0);
  useEffect(() => {
    if (id !== "add") userdetails();
  }, []);

  const userdetails = () => {
    setLoading(true);

    WebService.getAPI({
      action: `/country/${id}`,
    })
      .then((res: any) => {
        setLoading(false);
        setData(res.result);

        setValue("name", res.result.name);
        setValue("code", res.result.code);
        setIsAccess(res.result.certification_enabled);
     
      })
      .catch((e) => {
        setLoading(false);
        toast.error(e?.response?.data?.message);
      });
  };
  // ...existing code...
  const onSave = async (form: any) => {
    const payload = {
      uuid: id,
      name: form.name,
      code : form.code,
      certification_enabled: isAccess,
      
    };

    setShowLoader(true);
    try {
      if (id !== "add") {
        // Update
        const res: any = await WebService.putAPI({
          action: `/country/edit`,
          body: payload,
        });

        toast.success(res.message);
        setShowLoader(false);

        navigate(`/manage-countries`);
      } else {
        // Add
        const addPayload = {
          name: form.name,
          code : form.code,
            certification_enabled: isAccess,
        };

        const res: any = await WebService.postAPI({
          action: `/country/add`,
          body: addPayload,
        });

        toast.success(res.message || "Country added successfully");
        setShowLoader(false);

       navigate(`/manage-countries`);
      }
    } catch (e: any) {
      setShowLoader(false);
      toast.error(e?.response?.message || "Something went wrong");
      setError(true);
    }
  };

  return (
    <Container className="mt-5">
      {/* BACK BUTTON */}
      <Row className="align-items-center mb-4">
        <Col xs="auto">
          <Link
            to={`/manage-countries`}
            className="d-flex align-items-center text-decoration-none"
          >
            <BiArrowBack size={22} className="me-2 text-dark" />
            <span className="text-dark">Back</span>
          </Link>
        </Col>

        <Col className="text-center">
          <h1 className="font-20 font-bold m-0">
            {id !== "add" ? "Update Countries" : "Add Countries"}
          </h1>
        </Col>

        <Col xs="auto"></Col>
      </Row>

      {/* FORM */}
      <Row className="justify-content-center">
        <Col lg={10}>
          <Loader show={loading} />

          <Card className="p-4 shadow-sm">
            <Form onSubmit={handleSubmit(onSave)}>
              <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="name">
                    <Form.Label>Country Name</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Name"
                      {...register("name", { required: true })}
                    />
                  </Form.Group>

                  {errors.name && (
                    <small className="text-danger">Please enter name</small>
                  )}
                </Col>
              </Row>

                <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="code">
                    <Form.Label>Country Code</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter Code"
                      {...register("code", { required: false })}
                    />
                  </Form.Group>
                </Col>
              </Row>

              <Row className="mb-3">
                <Col lg={12}>
                  <Form.Group controlId="certificationAccess">
                    <Form.Check
                      type="checkbox"
                      id="certificationAccess"
                      className="chk-gap me-4"
                      label="Certification Access"
                      checked={isAccess === 1}
                      onChange={() =>
                        setIsAccess(isAccess === 1 ? 0 : 1)
                      }
                    />
                  </Form.Group>

                  
                </Col>
              </Row>

              {/* SAVE / UPDATE BUTTON */}
              <Button
                type="submit"
                className="btn btn-brand-1 d-block mx-auto mt-3"
                disabled={loader}
              >
                {loader && <Spinner size="sm" className="me-2" />}{" "}
                {id !== "add" ? "Update" : "Save"}
              </Button>
            </Form>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default AddCountries;
